import type { LegacySubscription } from '../../types';

export function hasPlan(legacySubscription: LegacySubscription) {
  const { _links } = legacySubscription;
  if (!_links) {
    return false;
  }
  return Object.keys(_links).includes('plan');
}
